import React from "react";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";

const EligibilityLoader = ({ isModalEnabled, setIsModalEnabled }) => {
  return (
    <Dialog
      open={isModalEnabled}
      onClose={() => setIsModalEnabled(!isModalEnabled)}
      as="div"
      className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-10 flex w-4/5 flex-col items-center justify-center rounded-2xl bg-white px-5 py-5 shadow-2xl md:w-3/5 lg:w-1/5">
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src={
            "https://assets.learntube.ai/files/PRICING/giphy.webp?ik-sdk-version=javascript-1.4.3&updatedAt=1662619425597"
          }
          transformation={[
            {
              height: "100",
              width: "100",
            },
          ]}
          className="h-40 "
        />
        <div className="text-center text-lg font-bold">
          Checking Learning Records & Eligibility...
        </div>
      </div>
    </Dialog>
  );
};

export default EligibilityLoader;
